import { GetAccountRequirementsResponse200 } from "waapi/palpatine-client/private/Accounts/GetAccountRequirements/getAccountRequirements.client.js";

export const doesItHaveRequirements = (requirements: GetAccountRequirementsResponse200["requirements"]): boolean =>
    Object.values(requirements).reduce<boolean>((acc, curr) => {
        if (!curr) return acc;
        if (Array.isArray(curr) && curr.length) return true;
        return acc;
    }, false);
